export default {
  /* Approved */
  minerva: state => state.showMinerva,
  showScope: state => state.showScope,
  graphicsQuality: state => state.graphicsQuality,
  tickDelay: state => state.tickDelay,
  blockCheckDelay: state => state.blockCheckDelay
}
